import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { useEffect, useMemo } from 'react';
import { SESSION_FINGERPRINT, USER_FINGERPRINT } from '@/utils/constans';
import { StorageManager } from '@/utils/storageManager.ts';

export const useFingerprint = () => {
  const sessionFingerprint = useMemo(
    () => 'session-' + Math.random().toString(36).substring(2, 9),
    []
  );

  const getSessionFingerprint = () => {
    if (!StorageManager.get(SESSION_FINGERPRINT)) {
      StorageManager.set(SESSION_FINGERPRINT, sessionFingerprint);
    }
  };

  const getFingerPrint = async () => {
    try {
      if (!StorageManager.get(USER_FINGERPRINT)) {
        const fp = await FingerprintJS.load();

        const { visitorId } = await fp.get();

        StorageManager.set(USER_FINGERPRINT, visitorId);
      }
    } catch (e) {
      console.log('[useFingerprint]: Failed to load]');
    }
  };

  useEffect(() => {
    getFingerPrint();
    getSessionFingerprint();
  }, []);
};
